import React from 'react';

const shellMollusk =
  'https://santaplaya-bucket.s3.amazonaws.com/shell_mollusk.webp';

const tostadas = [
  {
    name: 'Mixta',
    price: '$19',
    description: 'Fish ceviche, octopus, and shrimp.',
  },
  {
    name: 'Camaron',
    price: '$17',
    description: 'Shrimp ceviche.',
  },
  {
    name: 'Tropical',
    price: '$18',
    description: 'Fish, shrimp, mango, and jicama.',
  },
  {
    name: 'Pescado',
    price: '$14',
    description: 'Fish ceviche.',
  },
  {
    name: 'Atun',
    price: '$22',
    description: 'Bluefin tuna ceviche served with house sauce.',
  },
];

const ostiones = [
  {
    name: 'Ostiones En Su Concha',
    price: '$22',
    description: 'Oysters in the shell (6 pcs).',
  },
  {
    name: 'Ostiones Especiales',
    price: '$26',
    description: 'Oysters with octopus and shrimp ceviche (6 pcs).',
  },
  {
    name: 'Ostiones Yona',
    price: '$30',
    description: 'Oysters with scallop and shrimp ceviche (6 pcs).',
  },
  {
    name: 'Tiro De Ostion',
    price: '$7',
    description: 'Oyster shooter (non-alcoholic).',
  },
];

const TostadasOstionesSection: React.FC = () => {
  return (
    <section className="w-full bg-white py-12 px-4 lg:px-24">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Left Column: CEVICHE / TOSTADAS */}
        <div className="flex flex-col items-center justify-center md:border-r border-sea">
          <h2 className="font-charles text-maroon text-3xl mb-2 text-center">
            CEVICHE / TOSTADAS
          </h2>
          {/* Clarification Note */}
          <p className="font-prosto text-sea text-sm mb-4 text-center">
            Each item can be enjoyed either as a chilled ceviche bowl or served
            on a crispy tostada—just let us know your preference.
          </p>

          <ul className="space-y-4">
            {tostadas.map((item, idx) => (
              <li key={idx} className="font-prosto text-sea text-xl">
                <div className="flex justify-between">
                  <span>{item.name}</span>
                  <span className="font-bold">{item.price}</span>
                </div>
                {item.description && (
                  <p className="text-sm text-maroon/80 ml-2">
                    {item.description}
                  </p>
                )}
              </li>
            ))}
          </ul>

          {/* Sauce Options */}
          <div className="mt-6 border-t border-sea pt-4">
            <p className="font-prosto text-sea text-sm text-center">
              <strong>Sauce Options:</strong> All items come with your choice of
              sauce: Verde, Roja, Negra (House Sauce).
            </p>
          </div>
        </div>

        {/* Right Column: OSTIONES */}
        <div className="flex flex-col items-center justify-center">
          {/* Title */}
          <h2 className="font-charles text-maroon text-3xl mb-4 text-center">
            OSTIONES
            <span className="font-prosto text-sea block text-lg">OYSTERS</span>
          </h2>

          <ul className="space-y-4 ">
            {ostiones.map((item, idx) => (
              <li key={idx} className="font-prosto text-sea text-xl">
                <div className="flex justify-between">
                  <span>{item.name}</span>
                  <span className="font-bold">{item.price}</span>
                </div>
                {item.description && (
                  <p className="text-sm text-maroon/80 ml-2">
                    {item.description}
                  </p>
                )}
              </li>
            ))}
            {/* Shell at the bottom-right */}
            <div className="flex items-center justify-center">
              <img
                src={shellMollusk}
                alt="Shell Accent"
                className="w-24 md:w-32 opacity-90"
              />
            </div>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default TostadasOstionesSection;
